function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    }[char]))
}

export function showDirectoryLoading(vm, options = {}) {
    const {
        title = 'Processing',
        description = 'Please wait while the request is being completed.'
    } = options

    return vm.$swal({
        html: `
            <div class="directory-loading-swal__content">
                <span class="directory-loading-swal__spinner" aria-hidden="true"></span>
                <h2 class="directory-loading-swal__heading">${escapeHtml(title)}</h2>
                <p class="directory-loading-swal__message">${escapeHtml(description)}</p>
            </div>
        `,
        buttonsStyling: false,
        showConfirmButton: false,
        showCloseButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
            popup: 'directory-loading-swal',
            htmlContainer: 'directory-loading-swal__html'
        }
    })
}

export function closeDirectoryLoading(vm) {
    if (vm?.$swal?.close) {
        vm.$swal.close()
    }
}
